import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { MyIcon, IMG_DEFAULT } from "../../common/baseConfig"
import { Button, Spin } from "antd"
import { Link } from "react-router-dom"
import * as actions from './redux/actions';

export class ExperienceClass extends Component {
  static propTypes = {
    home: PropTypes.object.isRequired,
    actions: PropTypes.object.isRequired,
  };
  state = {
    PageIndex: 1,
    PageSize: 4,
    PageStatus: 1,
    isNext: false,
    isPrev: false,
  }
  componentDidMount() {
    this.loadList();
  }
  loadList() {
    const {
      PageIndex,
      PageSize,
      PageStatus,
    } = this.state;
    this.props.actions.fetchGetExperienceClass({ PageIndex, PageSize, PageStatus }).then(res => {

      if (res.SuccessResponse) {
        if (res.TotalCount > PageSize && PageIndex === 1) {
          this.setState({
            isNext: true,
          })
        }
      }
    });
  }
  onPrev() {
    let { PageIndex } = this.state;
    PageIndex--;
    this.setState({
      isPrev: PageIndex !== 1,
      isNext: true,
      PageIndex,
    }, () => {
      this.loadList();
    })
  }
  onNext() {
    let { PageIndex, PageSize, } = this.state;
    const { fetchGetExperienceClassTotal } = this.props.home;
    let total = fetchGetExperienceClassTotal;
    PageIndex++;
    this.setState({
      isNext: (total - PageSize * PageIndex) > 0,
      isPrev: true,
      PageIndex,
    }, () => {
      this.loadList();
    })
  }
  render() {
    const { isNext, isPrev } = this.state;
    const { fetchGetExperienceClassSuccess = [], fetchGetExperienceClassPending } = this.props.home;

    if (!fetchGetExperienceClassSuccess) return null;
    return (
      <div className="home-experience-class">
        {
          fetchGetExperienceClassSuccess.length > 0 && <div className="home-experience-class-inner">
            <h1>
              <p>体验中心</p>
              <p className="pagination">
                {isPrev && <span onClick={() => this.onPrev()}><MyIcon className="arrow-icon" type="iconwangzuo" /></span>}
                {isNext && <span onClick={() => this.onNext()}><MyIcon className="arrow-icon" type="iconwangyou-" /></span>}
              </p>
            </h1>
            <div className="home-experience-class-list">
              {
                fetchGetExperienceClassSuccess.map((item, key) => (
                  <div className="list-item" key={key}>
                    <img src={item.CoverPath || IMG_DEFAULT} alt="" />
                    <div className="content">
                      <p className="title">{item.Name}</p>
                    </div>
                    <div className="bottom-view">
                      <p>
                        <MyIcon className="num-icon" type="iconrenshu" />
                        <span>{item.BuyBase + item.BuyCount}</span>
                      </p>
                      <p>
                        <Link to={`/course/detail/${item.ID}`} target="_blank">
                          <Button className="try-btn" type="theme2" >
                            <span>免费试听</span>
                            <MyIcon type="iconmianfeishiting" className="try-icon" />
                          </Button>
                        </Link>
                      </p>
                    </div>
                  </div>
                ))
              }
              {fetchGetExperienceClassPending && <Spin size="large" className="loading-spin" />}
            </div>
          </div>
        }
      </div>
    );
  }
}

/* istanbul ignore next */
function mapStateToProps(state) {
  return {
    home: state.home,
  };
}

/* istanbul ignore next */
function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators({ ...actions }, dispatch)
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ExperienceClass);



// WEBPACK FOOTER //
// ./src/features/home/ExperienceClass.js